/**
 * Which kind of system a page is served from, decided from the page's host name by
 * `systemEnvironmentKindForHost` (helpers/system-environment.ts). Only Test and Dev are marked on
 * screen; Live renders exactly as it always has.
 */
export enum SystemEnvironmentKind {
  Live = 'Live',
  Test = 'Test',
  Dev = 'Dev',
}
